import React from 'react';
import { Label } from 'semantic-ui-react';
import DatasetConditionDescription from './DatasetConditionDescription';

const WorkspaceAllowListLabelGroup = ({ datasetCondition }) => (
  <DatasetConditionDescription datasetCondition={datasetCondition}>
    <Label.Group className="aridhia-tag">
      {datasetCondition.context.names.map((name) => (<Label key={name} content={name} />))}
    </Label.Group>
  </DatasetConditionDescription>
);

export default WorkspaceAllowListLabelGroup;
